module.exports = __webpack_public_path__ + "img/calls.a9f83837.svg";